<section class="section-hero overlay inner-page bg-image" style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                                      background-size: cover;" id="home-section">
    <div class="container" style="padding: 100px 0px 100px 0px;">
        <div class="row">
            <div class="col-md-10">
                <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">NOS EQUIPES
                </h1>
                <div class="custom-breadcrumbs">
                    <a style=" color: #FF5A00 " href="/">Accueil</a> <span class="mx-2 slash">/</span>
                    <a style=" color: #FF5A00 " href="#">Nos équipes</a>
                </div>
            </div>
        </div>
    </div>
</section>

<link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet">
<div class="container-fluid pt-5 Pb-5" style="background:#eee;">
    <h2 class="mb-5 customize-title" style="color: #00027D ;font-weight: bold; text-align: center;">
        NOS CONSULTANTS INTERNES</h2>
    <div class="container">

        <div class="row mb-3">
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#dgInfos" class="team-thumb overlay-image ">
                        <!-- <img src="assets/img/19.png" alt=""> -->
                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">Alfred BIAOU</span> -->
                                    <br> "Directeur Général du Groupe TALENTS PLUS"
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#dgInfos">Alfred BIAOU</h2>
                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="dgInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Alfred BIAOU</h3>
                                            <h6 class="theme-color lead">Directeur Général du Groupe TALENTS PLUS</h6>
                                            <p style="margin-right: 20px !important;"> Il totalise
                                                aujourd’hui plus de 27 ans d’expériences éprouvées dans
                                                le développement des outils GRH et le transfert des
                                                compétences dans ce domaine. Titulaire d’un DESS en
                                                GRH et Organisation, il a développé et forme les cadres et
                                                le personnel RH de plusieurs entreprises. Formateur &
                                                coach senior, il a animé une cinquantaine de formation en
                                                gestion des ressources humaines et développement du
                                                potentiel humain. Il a conduit plus de 3000 entretiens de
                                                recrutement et a à son actif plusieurs références telles que
                                                ECOBANK (Bénin, Niger),BAT au Niger, Bénin et Togo,
                                                SONAPRA, GIZ, Plan Bénin, TOTAL, CHEVRON, BSIC,
                                                Ministères (développement rural et finances) au Bénin,
                                                MTN BENIN, Africaine des Assurances, BCEAO, Groupe
                                                SFP, SONEB, SBEE, etc.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <img style="width: 70%;    border-radius: 10%;" src="assets/img/19.png">

                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#dtInfos" class="team-thumb overlay-image ">
                        <!-- <img src="assets/img/dt.webp" alt=""> -->
                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">BÉNÉDICTE OKIRI</span> -->
                                    <br> "Associée, Directrice Technique"
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#dtInfos">BÉNÉDICTE OKIRI</h2>
                    </div>
                    <div class="separator">
                    </div>

                    <div class="modal fade" id="dtInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Bénédicte OKIRI</h3>
                                            <h6 class="theme-color lead">"Associée, Directrice Technique"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Titulaire d’une Maitrise en sociologie et d’un Master en Gestion des
                                                Ressources
                                                Humaines, elle totalise plus de 17
                                                ans d’expériences dans la gestion des ressources humaines.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <!-- <img style="width: 70%;    border-radius: 10%;" src=""> -->

                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#dadjoInfos" class="team-thumb overlay-image ">

                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">Tonagnon DADJO</span> -->
                                    <br>
                                    <i>"Associé"</i>
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#dadjoInfos">Tonagnon DADJO</h2>

                    </div>
                    <div class="separator">
                    </div>

                    <div class="modal fade" id="dadjoInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Tonagnon DADJO</h3>
                                            <h6 class="theme-color lead">"Associé"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Il est titulaire d’un diplôme d’études professionnelles approfondies en
                                                * promotion de
                                                l’entrepreneuriat et d’un diplôme
                                                d’études comptables et financières.
                                                Il est formateur principal avec une cinquantaine de formation intra
                                                entreprise dans
                                                l’administration du réseau
                                                informatique, le team building, montage de plan d’affaires, formation
                                                des
                                                utilisateurs (ms office, messagerie,..),
                                                assistance aux utilisateurs.
                                                Actuellement consultant de la banque mondiale, son expertise dans
                                                plusieurs domaines
                                                est un atout.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <!-- <img style="width: 70%;    border-radius: 10%;" src=""> -->

                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#alainInfos" class="team-thumb overlay-image ">
                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">Alain Christophe MENSAH</span> -->
                                    <br> "Consultant interne"
                                </p>
                                <div class="">

                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#alainInfos">Alain C. MENSAH</h2>
                    </div>
                    <div class="separator ">
                    </div>
                    <div class="modal fade" id="alainInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Alain C. MENSAH</h3>
                                            <h6 class="theme-color lead">"Consultant interne"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Actuellement Directeur Technique à la Société Génie Incendie Santé
                                                Energie Afrique
                                                (GISEA SARL), filiale du groupe
                                                TALENTS PLUS, il est Technicien-Expert en Santé et Sécurité au Travail.
                                                Avec plus de
                                                15 ans d'expériences
                                                professionnelles dans le domaine, il a déjà formé les agents de
                                                plusieurs structures
                                                nationales et multinationales au
                                                Bénin, au Togo, en Guinée Conakry, au Cameroun, au Maroc et un peu
                                                partout en
                                                Afrique.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <!-- <img style="width: 70%;    border-radius: 10%;" src=""> -->
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div class="col-12 col-sm-6 col-lg-3 mt-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#etudesInfos" class="team-thumb overlay-image ">

                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p data-toggle="modal" data-target="#etudesInfos">
                                    <!-- <span class="accentcolor" style="font-weight:700;">Jacques DOSSOUHOUAN</span> -->
                                    <br> "Chef Missions Etudes, Assistance et Développement d’outils RH A TALENTS PLUS
                                    CONSEILS Bénin"
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#etudesInfos">Jacques DOSSOUHOUAN</h2>

                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="etudesInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Jacques DOSSOUHOUAN</h3>
                                            <h6 class="theme-color lead">"Chef Missions Etudes, Assistance et
                                                Développement d’outils RH A TALENTS PLUS
                                                CONSEILS Bénins"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Spécialiste en Organisation et Ressources Humaines, Chef Mission Etudes
                                                et
                                                Développement des Outils RH à Talents Plus
                                                Conseils Bénin, il totalise plus de vingt (20) ans d’expériences
                                                professionnelles, entre autres, dans la conduite des
                                                missions d’élaboration d’outils Rh, bilans de compétence, d’élaboration
                                                de fiches de
                                                poste, d’enquête salariale et de
                                                formation. Master en GRH, Master en Psychologie du Travail et des
                                                Organisations et
                                                DEA en Sociologie.
                                                Son activité à la tête de ce Département consiste à coordonner les
                                                missions d’audit
                                                organisationnel, d’élaboration de
                                                politiques et procédures RH, de manuel de gestion des ressources
                                                humaines, de
                                                convention collective, d’étude sur la
                                                rémunération, d’élaboration de grille salariale, d’évaluation du
                                                personnel,
                                                d’évaluation des Dirigeants d’organisation
                                                et d’assistance aux entreprises…
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <!-- <img style="width: 70%;    border-radius: 10%;" src=""> -->

                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 mt-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#edemInfos" class="team-thumb overlay-image ">

                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">Edem LEGBAGAH</span> -->
                                    <br> "Chef département Informatique, Recrutement et Assistance
                                    aux entreprises par intérim"
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#edemInfos">Edem LEGBAGAH</h2>

                    </div>
                    <div class="separator">
                    </div>

                    <div class="modal fade" id="edemInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Edem LEGBAGAH</h3>
                                            <h6 class="theme-color lead">"Chef département Informatique, Recrutement et
                                                Assistance
                                                aux entreprises par intérim"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Spécialiste en informatique et réseaux, il totalise plus de quinze (15)
                                                ans de
                                                pratique tant en informatique et Gestion
                                                des Ressources Humaines.

                                                Il est Chef Départements Recrutement et Assistance par intérim à TALENTS
                                                PLUS
                                                CONSEILS Bénin cumulativement à ses
                                                fonctions de Responsable Informatique à TALENTS PLUS AFRIQUE. De par ses
                                                fonctions,
                                                il participe activement à
                                                l’administration des tests psychotechniques ainsi que leur
                                                interprétation.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <!-- <img style="width: 70%;    border-radius: 10%;" src=""> -->
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 mt-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#formationInfos" class=" team-thumb overlay-image ">
                        <!-- <img src="assets/img/chefetudes.png" style="margin-top: -73px;" alt=""> -->
                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">Armand CODO</span> -->
                                    <br> "Chef département Formation "
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#formationInfos">Armand CODO</h2>

                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="formationInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Armand CODO</h3>
                                            <h6 class="theme-color lead">"Chef département Formation"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Titulaire d’un diplôme d’Inspecteur du Travail et de la Sécurité Sociale
                                                et d’un
                                                master en Gestion des Ressources
                                                Humaines, il est le Responsable du Département Formation du Cabinet
                                                Talents Plus
                                                Conseils. Il a une bonne maitrise des
                                                questions de la sécurité sociale et du droit du travail béninois et des
                                                pays de la
                                                sous-région. Il conduit des Mission
                                                de Recrutement, d’études RH, de gestion du personnel et, bien entendu,
                                                de la
                                                formation. Il a à son actif plus de 09
                                                ans de pratique en la matière. Il a déjà formé les cadres de plusieurs
                                                entreprises
                                                comme SIRB, MTN, ORABANK TOGO,
                                                ORABANK GUINEE, ORABANK BENIN, UNION DES MECKS DES ILES COMORES, HUAWEI,
                                                CDCB,
                                                CORISBANK, GROUPE SFP, SONIBANK, MAEP,
                                                ATDA, ASECNA, etc.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <img style="width: 70%;    border-radius: 10%;" src="assets/img/chefetudes.png">
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-3 mt-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#pmeInfos" class=" team-thumb overlay-image ">
                        <!-- <img src="assets/img/madama.png" alt=""> -->
                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">Adaman ALILOU</span> -->
                                    <br> "Chef département PME/PMI"
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#pmeInfos">Adaman ALILOU</h2>
                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="pmeInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Adaman ALILOU</h3>
                                            <h6 class="theme-color lead">"Chef département PME/PMI"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Il totalise aujourd’hui plus de 13 ans d’expériences éprouvées dans la
                                                pratique de
                                                l’accompagnement des entreprises à
                                                travers (i) le montage des dossiers de crédit (Elaboration de plan
                                                d’affaires et
                                                Note d’information bancaire) ; (ii) la
                                                facilitation de l’accès au financement ; (iii) le suivi-post financement
                                                et le
                                                contrôle d’utilisation de crédits ; (v)
                                                le renforcement des capacités/coaching entrepreneuriales/mentorat, la
                                                formation des
                                                MPME/PMI en gestion d’entreprises,
                                                marketing, éducation financière, etc.
                                                Titulaire d’un double Master en Entrepreneuriat et en Management de
                                                Projet de
                                                Développement, Formateur & coach selon la
                                                méthodologie Benibiz, il a accompagné une cinquantaine de chefs
                                                d’entreprises dans
                                                l’amélioration de la gestion de leur
                                                entreprise, la mobilisation de financement auprès de banques et
                                                microfinances.
                                                Il a pratiqué aussi la finance bancaire pour avoir travaillé à la NSIA
                                                BANK (ex
                                                Diamond Bank) en tant que
                                                chargé d’affaires.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <img style="width: 100%;    border-radius: 10%;margin-top: -50px;"
                                            src="assets/img/madama.png">

                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 mt-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#ciInfos" class="team-thumb overlay-image ">

                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">GUSTAVE HOUNKANNON</span> -->
                                    <br> "Chef de Mission adjoint de TALENTS PLUS CONSEILS en Côte d'Ivoire "
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#ciInfos">GUSTAVE HOUNKANNON</h2>

                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="ciInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">GUSTAVE HOUNKANNON</h3>
                                            <h6 class="theme-color lead">"Chef de Mission adjoint de TALENTS PLUS
                                                CONSEILS en Côte d'Ivoire"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Diplômé de l'Université d'Abomey Calvi d'où il est sorti avec une
                                                Maîtrise en Droit avec
                                                spécialisation en Sciences
                                                Politiques et Relations Internationales, Gustave HOUNKANNON est aussi
                                                titulaire d'un Diplôme
                                                Supérieur Spécialisé en
                                                Gestion, parcours Management des Ressources Humaines. Ces formations
                                                sont complétées par un Master
                                                en Ingénierie des
                                                Ressources Humaines obtenu au Centre Africain de Management et de
                                                Perfectionnement des Cadres
                                                (CAMPC).
                                                Collaborateur à Talents Plus Afrique depuis 2011 il est le chef de
                                                mission adjoint de la filiale
                                                de la Côte d'Ivoire,
                                                depuis 2014. Gestionnaire des Ressources Humaines, il est spécialiste de
                                                l'assistance à
                                                l'externalisation en gestion
                                                administrative du personnel, de la paie et en recrutement.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <img style="width: 70%;    border-radius: 10%;" src="assets/img/tpcci.png">
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-3 mt-3">
                <div class="team-boxes pb-3">

                    <div data-toggle="modal" data-target="#maliInfos" class="team-thumb overlay-image ">

                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">RENE COMLAN TOHOUENOU</span> -->
                                    <br> "Associé, Chef de Mission de TALENTS PLUS CONSEILS Mali"
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#maliInfos">RENE COMLAN TOHOUENOU</h2>

                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="maliInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">RENE COMLAN TOHOUENOU</h3>
                                            <h6 class="theme-color lead">"Chef de Mission adjoint de TALENTS PLUS
                                                CONSEILS Mali"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Gestionnaire d’entreprise, Psychologue du Travail et des Organisations
                                                bilingue, il
                                                est depuis près de quinze ans Gérant
                                                de la filiale du Groupe Talents Plus Afrique au Mali où il gère un
                                                effectif moyen de
                                                250 personnes. Il est spécialisé
                                                non seulement en audit, formation, étude et dialogue social mais
                                                également en
                                                recrutement et assistance
                                                RH/gestion/organisation.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <img style="width: 70%;    border-radius: 10%;" src="assets/img/Mali.png">
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div class="col-12 col-sm-6 col-lg-3 mt-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#wassiInfos" class=" team-thumb overlay-image ">

                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">Wassi LIAMIDI SALAKO</span> -->
                                    <br> "Administrateur des Ressources Humaines. Associé, Expert principal du groupe"
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#wassiInfos">Wassi LIAMIDI SALAKO</h2>

                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="wassiInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Wassi LIAMIDI SALAKO</h3>
                                            <h6 class="theme-color lead">"Administrateur des Ressources Humaines.
                                                Associé, Expert principal du groupe"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Ancien Directeur des Ressources Humaines durant 18 ans tant à Bénin
                                                Sheraton
                                                Hôtel, Plan International Bénin qu’à
                                                Plan International Niger, avec des expériences de Consultation au Bénin,
                                                Tchad,
                                                Mali, Niger, et ailleurs, il jouit d’une
                                                expertise avérée en Administration du personnel et application du droit
                                                social (dont
                                                plus d’une vingtaine comme
                                                formateur) aussi bien dans la Fonction Publique que dans le secteur non
                                                gouvernemental. Il a été ancien chef du
                                                personnel à la Caisse Nationale de Sécurité Sociale et au Ministère en
                                                Charge du
                                                Travail et de la Fonction Publique.
                                                Wassi LIAMIDI, Expert consultant, dispose d’un savoir-faire éprouvé dans
                                                l’interprétation, la mise en œuvre du droit
                                                social, la conception des outils et documents de pilotage des ressources
                                                humaines
                                                Il est l’auteur de l’ouvrage technique <b><q> Tout Sur l’Administration
                                                        du
                                                        Personnel </q></b> , paru
                                                en 2019 aux éditions Talents Plus.
                                                Il est diplômé d’un DECS équivalent au DESS en Administration Générale
                                                et
                                                Territoriale à l’ENAM, d’une Maîtrise en
                                                Gestion du Personnel et d’un Diplôme Universitaire de Technologie en
                                                Gestion du
                                                Personnel à l’UNIVERSITE PARIS XIII
                                                (FRANCE).
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <!-- <img style="width: 70%;    border-radius: 10%;" src=""> -->
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>



    </div>
    <h2 class="mb-5 mt-5 customize-title" style="color: #00027D ;font-weight: bold; text-align: center;">
        QUELQUES CONSULTANTS EXTERNES
    </h2>
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#badingaInfos" class="team-thumb overlay-image ">

                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">Aristide BADINGA</span> -->
                                    <br>
                                    "Consultant"
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#badingaInfos">Aristide BADINGA</h2>
                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="badingaInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Aristide BADINGA</h3>
                                            <h6 class="theme-color lead">"Consultant"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Consultant-formateur et auteur de plusieurs ouvrages dédiés au monde
                                                professionnel, il
                                                est titulaire d’une maîtrise en
                                                sciences de gestion, option Marketing. Il conçoit des modules de
                                                formation qu’il anime
                                                et dont il assure le
                                                suivi-évaluation sur différents thèmes dans les domaines du Marketing &
                                                Actions
                                                Commerciales, de la Communication, du
                                                Management, de l’Organisation et des Techniques Administratives, et du
                                                Développement
                                                personnel. Ayant à son actif plus
                                                de 15 ans d’expériences, il a formé les cadres de plusieurs structures
                                                au Bénin comme
                                                dans la sous-région en gestion de
                                                la clientèle et qualité de service.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <!-- <img style="width: 70%;    border-radius: 10%;" src=""> -->
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#codjiaInfos" class="team-thumb overlay-image ">

                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">Frédéric Cokou CODJIA</span> -->
                                    <br> "Consultant"
                                </p>
                                <div class="">
                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#codjiaInfos">Frédéric Cokou CODJIA</h2>
                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="codjiaInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">Frédéric Cokou CODJIA</h3>
                                            <h6 class="theme-color lead">"Consultant"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Expert-Comptable avec un double diplôme en Technique d’Audit et Contrôle
                                                de gestion,
                                                Comptabilité, Banque, Finances puis
                                                en managériale (Economie, Planification, Financement et Gestion des
                                                Organisations), il
                                                totalise plus de 20 ans
                                                d’expérience. Il est commissaire aux comptes et Coordonnateur des
                                                Départements
                                                Techniques de CANAL AUDIT avec un domaine
                                                d’expertise très étendu. Il possède une parfaite maîtrise des procédures
                                                financières et
                                                de passation des marchés des
                                                institutions internationales telles que le PNUD, la Banque Mondiale, le
                                                FMI, la BAD,
                                                l’UE.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <!-- <img style="width: 70%;    border-radius: 10%;" src=""> -->
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#abouoInfos" class="team-thumb overlay-image ">

                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">René ABOUO N’GUESSAN</span> -->
                                    <br> "Consultant"
                                </p>
                                <div class="">

                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#abouoInfos">René ABOUO N’GUESSAN</h2>
                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="abouoInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">René ABOUO N’GUESSAN</h3>
                                            <h6 class="theme-color lead">"Consultant"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Il est titulaire d’une Maîtrise en Sciences Economiques, option gestion,
                                                et d’un Diplôme
                                                d’études Approfondies de
                                                Contrôle de gestion de l’Université d’ABIDJAN.
                                                Il totalise plus de 40 ans d’expériences pratiques ( dont 18 ans
                                                en banques
                                                commerciales et 22 ans en
                                                microfinance) ,aux postes de cadre ,de Conseiller de Président Directeur
                                                Général
                                                d’Etablissement Financier de premier
                                                groupe de l’UEMOA, de Directeur Général et Directeur Exécutif de
                                                plusieurs Sociétés de
                                                capitaux et Institutions de
                                                Microfinance, ainsi que l’exercice de gouvernance de grandes
                                                Institutions Ivoiriennes et
                                                Africaines dans le domaine de
                                                la Finance Inclusive.
                                                Il lui a été permis dans le cadre de ses expériences professionnelles,
                                                de participer à
                                                plusieurs ateliers et forum de
                                                haut niveau, traitant des questions de stratégies de réduction de la
                                                pauvreté en Afrique
                                                et dans le monde, tels le
                                                Sommet Mondial du Microcrédit, des ateliers de validation de politiques
                                                nationales de
                                                Microfinance, des programmes
                                                d’appui au développement du secteur financier. Il est Expert-Formateur
                                                du CFPB (Centre
                                                de Formation à la Profession
                                                Bancaire de Paris), de plusieurs cabinets (PLURIEX, WAM-CC,
                                                IGEAMA-AFRIQUE,
                                                PERFORMANCE-BANCAIRE, Talent+ BENIN…), du
                                                CAMPC (Centre Africain de Management et Perfectionnement des Cadres),et
                                                de INPHB-ESCAE
                                                (Institut Nationale Polytechnique
                                                HB), etc…

                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <!-- <img style="width: 70%;    border-radius: 10%;" src=""> -->
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="team-boxes pb-3">
                    <div data-toggle="modal" data-target="#jeromeInfos" class="team-thumb overlay-image ">

                        <div class="clear">
                        </div>
                        <div class="mask team_quote">
                            <div class="port-zoom-link">
                                <p>
                                    <!-- <span class="accentcolor" style="font-weight:700;">DANDJINOU JEROME</span> -->
                                    <br> "Consultant"
                                </p>
                                <div class="">

                                    <!-- <a href=""><i class="fa fa-envelope"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-info">
                        <h2 data-toggle="modal" data-target="#jeromeInfos">DANDJINOU JEROME</h2>

                    </div>
                    <div class="separator">
                    </div>
                    <div class="modal fade" id="jeromeInfos" tabindex="-1" role="dialog"
                        aria-labelledby="exampleModalCenterLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content m-5">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-lg-8 mt-5">
                                        <div class="about-text go-to">
                                            <h3 class="dark-color">DANDJINOU JEROME</h3>
                                            <h6 class="theme-color lead">"Consultant"</h6>
                                            <p style="margin-right: 20px !important;">
                                                Ingénieur principal des ponts et chaussées, et Gestionnaire de ports
                                                (Port Autonome de
                                                Cotonou) et d’aéroports
                                                (IAMTI-CANADA), Monsieur DANDJINOU est un expert formateur et Auditeur
                                                QHSE.
                                                En environ 38 ans, il a été Administrateur dans plusieurs entreprises
                                                de secteurs
                                                divers dont le secteur aéronautique
                                                (SIBA-Aviation Civile du Bénin, ASECNA SERVICES TCHAD, ADL-Gabon ;
                                                HPG-Gabon ;
                                                ADC-Cameroun ; SHS-Sénégal, etc)
                                                Il a été directeur de l’ERNAM- Dakar cumulativement à son poste de
                                                Responsable Qualité
                                                de l’ASECNA.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"
                                        style="display: flex;align-items: flex-start;align-content: space-between;  flex-direction: row;justify-content: space-around;">
                                        <!-- <img style="width: 70%;    border-radius: 10%;" src=""> -->
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Fermer</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


        </div>
    </div>

</div>